import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Icon } from '../Icon';

const LeftMenu = () => {
  const location = useLocation();
  const isActive = (pathname: string) => {
    return location.pathname === pathname ? 'active' : '';
  };

  return (
    <>
      <Wrap>
        <Link to="/admin/userlist" className="logo-box img-box">
          <Icon
            name="LogoManager"
            size="100%"
            color="#333333"
            color2="#777777"
          />
        </Link>
        <ul className="menu-box">
          {/* 지금은 메뉴가 1개여서 나중에 추가 메뉴가 늘어나면 기능 구현 예정 */}
          <li className="active">
            <Link to="/admin/userlist">
              <Icon name="SettingIcon" size="20px" color="#2869E2" />
              <h3>관리</h3>
            </Link>
            <ul className="depth-2-menu-box">
              <li className={isActive('/admin/userlist')}>
                <Link to="/admin/userlist">회원 목록</Link>
              </li>
              <li className={isActive('/admin/history')}>
                <Link to="/admin/history">히스토리 목록</Link>
              </li>
            </ul>
          </li>
        </ul>
      </Wrap>
    </>
  );
};

export default LeftMenu;

const Wrap = styled.div`
  width: 240px;
  min-height: 100vh;
  border-right: 1px solid #dbdbdb;
  box-sizing: border-box;
  background: #fff;
  .logo-box {
    width: 180px;
    margin: 28px auto 0 auto;
  }
  .menu-box {
    margin-top: 40px;
    > li > a {
      display: flex;
      align-items: center;
      padding: 20px 28px;
      gap: 16px;
      position: relative;
      h3 {
        font-size: 16px;
        color: #555;
      }
    }
    > li.active > a {
      background: #e8effc;
      &::after {
        content: '';
        position: absolute;
        width: 5px;
        height: 100%;
        background: ${(props) => props.theme.mainColor1};
        top: 0;
        right: 0;
      }
      h3 {
        color: ${(props) => props.theme.mainColor1};
        font-weight: 700;
      }
    }
    .depth-2-menu-box > li {
      a {
        box-sizing: border-box;
        padding: 8px 28px 8px 64px;
        font-size: 15px;
        color: #777;
      }
    }
    .depth-2-menu-box > li:first-child {
      a {
        padding: 24px 28px 16px 64px;
      }
    }
    .depth-2-menu-box > li.active {
      a {
        color: ${(props) => props.theme.mainColor1};
        font-weight: 500;
      }
    }
  }
`;
